import { Bar, BarChart, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Card } from "../../../../components/ui/card";
import { ScrollArea } from "../../../../components/ui/scroll-area";
import type { SpecialtyChartData } from "../../../../shared/schema";

interface SpecialtyChartProps {
  data: SpecialtyChartData[];
  title?: string;
}

const COLORS = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))",
];

export function SpecialtyChart({ data, title = "Phân bổ theo chuyên khoa" }: SpecialtyChartProps) {
  // Only take top 10 for cleaner display
  const displayData = data.slice(0, 15);
  const chartHeight = Math.max(300, displayData.length * 40);

  return (
    <Card className="p-6 border border-card-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        <span className="text-xs text-muted-foreground">Tuần này</span>
      </div>
      <ScrollArea className="h-[360px]">
        <div style={{ height: chartHeight, minHeight: 300 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart 
              data={displayData} 
              layout="vertical" 
              margin={{ top: 0, right: 40, left: 0, bottom: 0 }}
            >
              <XAxis 
                type="number"
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }}
              />
              <YAxis 
                type="category"
                dataKey="specialtyName"
                width={100}
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 11, fill: "hsl(var(--foreground))" }}
              />
              <Tooltip
                content={({ active, payload }) => {
                  if (!active || !payload || !payload.length) return null;
                  const item = payload[0].payload as SpecialtyChartData;
                  return (
                    <div className="bg-popover border border-popover-border rounded-lg px-3 py-2 shadow-lg">
                      <p className="text-sm font-medium text-foreground">{item.specialtyName}</p>
                      <p className="text-sm text-muted-foreground">
                        {item.appointments} lịch hẹn ({item.percentage}%)
                      </p>
                    </div>
                  );
                }}
              />
              <Bar dataKey="appointments" radius={[0, 4, 4, 0]} maxBarSize={28}>
                {displayData.map((_, index) => (
                  <Cell 
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </ScrollArea>
    </Card>
  );
}
